import React, { useState } from 'react'
import { pascalCase } from 'change-case'
import { connect } from 'react-redux'
import { Field, getFormValues, SubmissionError } from 'redux-form'
import { Button, Confirm } from 'semantic-ui-react'

import { StdCard } from 'components'
import { appLoading } from 'ducks/app'
import { actionVM, updateVM, checkTaxIdAvailable } from 'ducks/vendorMaintenance'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { Cont } from './styled'
import { checkAttachmentRequire } from '../../AttributeData'

// import r from 'reactotron-react-js'

const Approve = (props) => {
  const {
    handleSubmit,
    actionVM,
    updateVM,
    valueForm,
    history,
    attachmentGroups,
    appLoading
  } = props
  const approverAction = valueForm.actions || ['Approve', 'Revise', 'Reject']

  const [submitActionName, setSubmitActionName] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [confirmMessage, setConfirmMessage] = useState('')

  const validateAccFormData = (values) => {
    var errors = {}
    if (values.purpose === 'change') {
      if (values.accountingViewLoaded === false) {
        // ignore validate acc view in case un change acc data  
        return errors
      }
    }

    validations(values, 'reconciliationAccount', [vCase.require], errors)
    validations(values, 'sortKey', [vCase.require], errors)
    validations(values, 'planningGroup', [vCase.require], errors)
    validations(values, 'accPaymentTerms', [vCase.require], errors)
    validations(values, 'paymentMethod', [vCase.require], errors)

    if ((values.paymentMethod || []).length === 0) {
      errors.paymentMethod = 'Require!'
    }

    if (values.accountGroup === 'ZRPT') {
      validations(values, 'tradingPartner', [vCase.require], errors)
    }

    validations(values, 'branchCode', [vCase.require], errors)
    validations(values, 'branchDescription', [vCase.require], errors)

    return errors
  }

  const validateGeneralFormData = (values) => {
    const documentTypes = attachmentGroups.data.find(a => a.bpGroup === values.accountGroup) || { attachments: [] }
    var errors = {}

    validations(values, 'title', [vCase.require], errors)
    validations(values, 'requesterUser', [vCase.require], errors)
    validations(values, 'documentDate', [vCase.require], errors)
    validations(values, 'purpose', [vCase.require], errors)
    validations(values, 'accountGroup', [vCase.require], errors)

    if (values.purpose && values.purpose === 'create') {
      if (values.purpose === 'create') {
        validations(values, 'companyCode', [vCase.require], errors)
      }

      if (values.purpose === 'change') {
      }

      if (values.purpose === 'copy') {
      }

      if (values.purpose === 'block') {
      }
    }

    validations(values, 'vendorType', [vCase.require], errors)
    validations(values, 'vendorName1', [vCase.require, vCase.maxLength40], errors)
    validations(values, 'vendorName2', [vCase.maxLength40], errors)
    validations(values, 'vendorName3', [vCase.maxLength40], errors)
    validations(values, 'vendorName4', [vCase.maxLength40], errors)
    validations(values, 'searchName', [vCase.require, vCase.maxLength20], errors)

    validations(values, 'industry', [vCase.require], errors)
    if (values.accountGroup === 'ZFOV') {
      validations(values, 'taxId', [vCase.maxLength20], errors)
    } else {
      validations(values, 'taxId', [vCase.require, vCase.maxLength20], errors)
    }
    validations(values, 'country', [vCase.require], errors)
    validations(values, 'province', [vCase.require], errors)
    validations(values, 'district', [vCase.require], errors)
    validations(values, 'subDistrict', [vCase.require], errors)
    validations(values, 'houseNumber', [vCase.require, vCase.maxLength10], errors)
    validations(values, 'buildingOrRoomNo', [vCase.require, vCase.maxLength60], errors)
    validations(values, 'street', [vCase.maxLength40], errors)
    validations(values, 'postalCode', [vCase.require, vCase.maxLength10], errors)

    if (['ZDOV', 'ZFOV', 'ZRPT', 'ZOTV'].includes(values.accountGroup)) {
      if ((values.vendorUsers || []).filter(u => u.registerEzProcure === true).length === 0) {
        if (values.notRegisterRemark === undefined || values.notRegisterRemark === null ||values.notRegisterRemark === '') {
          errors.notRegisterRemark = 'Required!'
        }
      }
    }

    if (values.paymentTypeTransfer) {
      if ((values.vendorBanks || []).length === 0) {
        errors.paymentType = ' Minimum 1 row of bank account required!'
      }
    }

    if (values.usePurchasingView) {
      if (values.purpose === 'create' || values.purpose === 'change') {
        validations(values, 'purchasingOrg', [vCase.require], errors)
      }

      validations(values, 'orderCurrency', [vCase.require], errors)
      validations(values, 'paymentTerms', [vCase.require], errors)

      if (values.incoterm !== undefined && values.incoterm !== null && values.incoterm !== '') {
        validations(values, 'incotermsLocation', [vCase.require], errors)
      }
    }

    if (values.paymentTypeTransfer) {
      if ((values.vendorBanks || []).length === 0) {
        errors.paymentType = ' Minimum 1 row of bank account required!'
      }
    }

    documentTypes.attachments.forEach(d => {
      if (checkAttachmentRequire(d, values)) {
        if (((values[d.code] || []).length === 0) && ((values[`attachment${d.code.replace('VMA', '')}`] || []).length === 0)) {
          errors[d.code] = 'Require!'
        }
      }
    })

    return errors
  }

  const submitValidate = (action) => {
    setSubmitActionName(action)
    var errors = {}
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100) // simulate server latency
      .then(() => {
        if (action.toLowerCase() === 'reject' || action.toLowerCase() === 'cancel') {
          if ((valueForm.comment && valueForm.comment.trim().length === 0) || !valueForm.comment) {
            errors.comment = 'Required!'
            scrollToFirstValidateFailElement(errors)
            throw new SubmissionError(errors)
          }
        } else {
          if (action.toLowerCase() === 'resubmit') {
            if (valueForm.purpose !== 'block') {
              errors = validateGeneralFormData(valueForm)
            }
          } else {
            if (valueForm.purpose !== 'block') {
              errors = validateAccFormData(valueForm)
            }
          }

          if (Object.keys(errors).length) {
            scrollToFirstValidateFailElement(errors)
            throw new SubmissionError(errors)
          }
        }
        setShowConfirm(true)
      })
  }

  const callUpdate = () => {
    updateVM(
      valueForm, 
      false, 
      history,
      appLoading, 
      () => actionVM({
        docId: valueForm.id,
        sn: valueForm.sn,
        action: submitActionName,
        comment: valueForm.comment,
        commentAttachments: valueForm.commentAttachments
      }, history)
    )
  }

  const submitAction = () => {
    setShowConfirm(false)

    const { purpose, vendorCode, vendorType, taxId } = valueForm
    
    if (submitActionName === 'Resubmit' && (purpose === 'create' || purpose === 'change')) {
      props.checkTaxIdAvailable(
        { vendorCode, vendorType, taxId }, 
        () => { callUpdate() }, 
        (message) => {
          setShowConfirmModal(true)
          setConfirmMessage(message)
        }
      )
    } else {
      callUpdate()
    }
  }

  return (
    approverAction.length === 0 ? null :
      <StdCard title='Action for Approval' highlight style={{ marginTop: '1rem' }} enableCollapse={false}>
        <Cont>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Field
              name='comment'
              label='Your Comment'
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} />
            <Field
              name='commentAttachments'
              label='Attachments'
              type={type.file}
              component={FieldInput}
              containerStyle={{ marginRight: 0 }}
            />
            <div style={{ marginTop: '1rem', display: 'flex' }}>
              {
                approverAction.map((item) =>
                  <Button
                    key={item}
                    type='button'
                    color={`${(item.toLowerCase() === 'reject' || item.toLowerCase() === 'cancel') ? 'red' : 'green'}`}
                    onClick={handleSubmit(() => submitValidate(item))}
                  >
                    {pascalCase(item)}
                  </Button>
                )
              }
            </div>
          </div>
          <Confirm
            size='mini'
            open={showConfirm}
            onCancel={() => setShowConfirm(false)}
            onConfirm={() => submitAction()}
          />
        </Cont>
        <Confirm 
          open={showConfirmModal}
          header='Warning!'
          content={
            <div style={{ padding: '1.25rem' }}>
              <p>{confirmMessage}</p>
              <p>Are you sure to submit Business Partner Data?</p>
            </div>
          }
          confirmButton='Yes'
          cancelButton='No'
          onConfirm={() => {
            setShowConfirmModal(false)
            callUpdate()
          }}
          onCancel={() => setShowConfirmModal(false)}
        />
      </StdCard>
  )

}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formVendorMaintenance')(state) || {},
    attachmentGroups: state.vendorMaintenance.attachmentGroups
  })
}

const mapDispatchToProps = {
  updateVM,
  actionVM,
  appLoading,
  checkTaxIdAvailable
}

export default connect(mapStateToProps, mapDispatchToProps)(Approve)
